import { render, staticRenderFns } from "./ShenPiBaoXiao.vue?vue&type=template&id=513c46ca&scoped=true&"
import script from "./ShenPiBaoXiao.vue?vue&type=script&lang=js&"
export * from "./ShenPiBaoXiao.vue?vue&type=script&lang=js&"
import style0 from "./ShenPiBaoXiao.vue?vue&type=style&index=0&id=513c46ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c46ca",
  null
  
)

export default component.exports